import React from "react";
import {
    Box,
    Button,
    Grid,
    Typography
} from "@material-ui/core";
import {Controller} from "react-hook-form";
import {CKEditor} from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import editorConfiguration
    from "../../../../util/EditorConfiguration";
import TextField from "@material-ui/core/TextField";

const injectTdParagraphMargins = (html) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    doc.querySelectorAll("td p").forEach((p) => {
        p.style.margin = "0";
    });
    return doc.body.innerHTML;
};

const EmailTemplateSubmissionForm = (props) => {
    const {
        name,
        display,
        initialValues,
        handleSubmit,
        onSubmit,
        control,
        classes,
        disabled,
    } = props;
    return (
        <form onSubmit={handleSubmit(onSubmit)}>

            <Box fontWeight={900} fontSize={13}  mt={2} mb={2}
                 width="100%">
                <Grid container direction="vertical"
                      spacing={3}>
                    <Grid item xs={12}>
                        <Controller
                            name={`${name}.subjectEN`}
                            control={control}
                            render={({
                                         field,
                                         fieldState: {error}
                                     }) => (
                                <TextField
                                    label={`${display} Email Subject (English)`}
                                    variant="outlined"
                                    margin="dense"
                                    className={classes.textInput}
                                    fullWidth
                                    {...field}
                                    error={!!error}
                                    helperText={error ? error.message : ""}
                                />
                            )}
                        />
                    </Grid>
                </Grid>
                <Typography variant="p">
                    {display} Email Content (English)
                </Typography>
            </Box>

            <Grid item xs={12}>
                <Controller
                    name={`${name}.contentEN`}
                    control={control}
                    render={({
                                 field,
                                 fieldState: {error}
                             }) => (
                        <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={field.value}
                            disabled={disabled}
                            onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                editor &&
                                editor.setData(
                                    editor.getData() || initialValues[name].contentEn || ''
                                );
                            }}
                            onChange={(event, editor) => {
                                const data = injectTdParagraphMargins(editor.getData());
                                field.onChange(data);
                                // console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                            }}
                        />
                    )}
                />
            </Grid>

            <Box fontWeight={900} fontSize={13} mt={4}
                 mb={2} width="100%">
                <Grid item xs={12}>
                    <Controller
                        name={`${name}.subjectTC`}
                        control={control}
                        render={({
                                     field,
                                     fieldState: {error}
                                 }) => (
                            <TextField
                                label={`${display} Email Subject (Traditional Chinese)`}
                                variant="outlined"
                                margin="dense"
                                className={classes.textInput}
                                fullWidth
                                {...field}
                                defaultValue={field.value}
                                error={!!error}
                                helperText={error ? error.message : ""}
                            />
                        )}
                    />
                </Grid>
                <Typography variant="p">
                    {display} Email Content (Traditional
                    Chinese)
                </Typography>
            </Box>

            <Grid item xs={12}>
                <Controller
                    name={`${name}.contentTC`}
                    control={control}
                    render={({
                                 field,
                                 fieldState: {error}
                             }) => (
                        <CKEditor
                            editor={Editor}
                            config={editorConfiguration}
                            data={field.value}
                            disabled={disabled}
                            onReady={(editor) => {
                                // You can store the "editor" and use when it is needed.
                                editor &&
                                editor.setData(
                                    editor.getData() || initialValues[name].contentTC || ''
                                );
                            }}
                            onChange={(event, editor) => {
                                const data = injectTdParagraphMargins(editor.getData());
                                field.onChange(data);
                                // console.log({ event, editor, data });
                            }}
                            onBlur={(event, editor) => {
                                console.log("Blur.", editor);
                            }}
                            onFocus={(event, editor) => {
                                console.log("Focus.", editor);
                            }}
                        />
                    )}
                />
            </Grid>

            {disabled || (
                <div className={classes.buttonGroup}>
                    <Button
                        type="submit"
                        variant="contained"
                        disableElevation
                        style={{
                            color: "white",
                            background: "#306F9D",
                            marginRight: "5px",
                            padding: "9px 16px",
                        }}
                    >
                        Save
                    </Button>
                </div>
            )}
        </form>
    );
};

export default EmailTemplateSubmissionForm;
